import React, {Fragment, useRef, useState} from 'react';
import './home.css';
import LinkMenu from "../linkMenu/linkMenu";
import {useSelector} from "react-redux";
import {Route, Routes} from "react-router-dom";
import drive from "../../drive";
import {isMobileDevice} from "../../../utils/utils";
import {GroupDetails} from "../../group";
import auth from "../../../utils/authentication";
import SharedFile from "../../public/sharedFile/sharedFile";
import LoginPage from "../../users/loginPage/loginPage";
import Cap17driveSearcher from "../../cap17drive/cap17driveSearcher/cap17driveSearcher";
import useSquadflixTv from "../../../hooks/useSquadflixTv";
import useDownloadStore from "../../../store/downloadStore";
import DownloadQueue from "../../drive/downloadQueue/downloadQueue";

const UnauthorizedHome = () => {
    const [isOpen, setIsOpen] = useState(false);
    const buttonToggleContextual = useRef(null);
    const isUploading = useSelector(drive.selectors.isUploading);
    const squadflixTvHook = useSquadflixTv();
    const {state} = useDownloadStore(state => state);
    const {currentFile: downloadingFile} = state;

    function toggleContextualMenu() {
        setIsOpen(!isOpen);
        buttonToggleContextual.current.click();
    }

    const mainRoutes = (

        <Routes>
            <Route path="/shared-files/:id" element={<SharedFile/>}/>
            <Route path="/groups/group-details/:id" element={<GroupDetails/>}/>
            {!auth.currentUser && <Route path="*" element={<LoginPage/>}/>}
        </Routes>
    );

    const contextualRoutes = (
        <Routes>
            <Route path="*" element={<Cap17driveSearcher navigateToSearch onlyInput/>}/>
        </Routes>
    );

    return (
        <div className="d-flex flex-row col-12 align-items-stretch"
             style={{height: window.innerHeight}}>
            {!isMobileDevice() &&
                <div className="p-4 pe-3 squaddisk-home__aux-columns squaddisk-home__aux-columns--left" id="link-menu"
                     style={{
                         overflowX: "hidden",
                     }}>
                    <LinkMenu/>
                </div>}
            <div
                className={"squaddisk-home__main-viewer  pt-4" + (!isMobileDevice() ? " pb-4 container" : " container-phone")}
                id="home__scrollContainer"
                style={{
                    height: isMobileDevice() ? (window.innerHeight - 60 + 'px') : 'auto',
                    paddingBottom: (isMobileDevice() && (isUploading || downloadingFile || squadflixTvHook.connectedReceptor)) ? '95px' : '0px',
                }}>
                <>
                    <DownloadQueue/>
                    {mainRoutes}
                </>
            </div>
            {!isMobileDevice() &&
                <div className="p-4 ps-3 squaddisk-home__aux-columns squaddisk-home__aux-columns--right"
                     id="contextual-menu" style={{}}>
                    {contextualRoutes}
                </div>}

            {isMobileDevice() && <div className="home__linKMenuPhone">
                <LinkMenu isOpen={isOpen} toggleContextualMenu={toggleContextualMenu}/>
            </div>}

        </div>
    );
};

export default UnauthorizedHome;
